import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgmCoreModule } from '@agm/core';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import { CheckcoverageComponent } from './checkcoverage.component';
import { CheckcoverageRoutingModule } from './checkcoverage-routing.module';


@NgModule({
  imports: [
    CommonModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBbHlZ2lyrZtAqRX2sFO1riNdvKaSmfo4w',
      libraries: ['places']
    }),
    AgmSnazzyInfoWindowModule ,
    CheckcoverageRoutingModule,
  ],
  exports: [],
  declarations: [
    CheckcoverageComponent
  ],
  providers: [],
})
export class CheckcoverageModule { }
